import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert"
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar"
import {
  Item,
  ItemContent,
  ItemDescription,
  ItemMedia,
  ItemTitle,
} from "@/components/ui/item"
import { AlertTriangleIcon } from "lucide-react"
export default function EditOverview() {
  return (
    <div className="bg-secondary rounded-md grid gap-4 md:col-span-4 sm:col-span-2 w-full sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-1 p-6">
      <div className="w-full">
        <Alert className="border-yellow-200 bg-yellow-50 text-yellow-800 dark:border-yellow-800 dark:bg-yellow-950/30 dark:text-yellow-200 [&>svg]:text-yellow-600 dark:[&>svg]:text-yellow-400">
          <AlertTriangleIcon />
          <AlertTitle>No Architect Attribution</AlertTitle>
          <AlertDescription className="text-yellow-700 dark:text-yellow-300">
            Your project doesn't have an attributed architect. You can choose up
            to 3 architects to interview with. Or, you can set your project as
            public and let architects come to you with proposals
          </AlertDescription>
        </Alert>
      </div>
      <Item variant="muted" className="border-1 border-white">
        <ItemMedia>
          <div className="*:data-[slot=avatar]:ring-background flex -space-x-2 *:data-[slot=avatar]:ring-2 *:data-[slot=avatar]:grayscale">
            <Avatar className="hidden sm:flex">
              <AvatarImage
                src="   https://cdn-icons-png.flaticon.com/512/149/149071.png "
                alt="@shadcn"
              />
              <AvatarFallback>CN</AvatarFallback>
            </Avatar>
            <Avatar className="hidden sm:flex">
              <AvatarImage src="https://cdn-icons-png.flaticon.com/512/149/149071.png " />
              <AvatarFallback>LR</AvatarFallback>
            </Avatar>
          </div>
        </ItemMedia>
        <ItemContent>
          <ItemTitle>2/3 Candidates Selected</ItemTitle>
          <ItemDescription>
            No architecture expert has been attributed yet to this project
          </ItemDescription>
        </ItemContent>
      </Item>
    </div>
  )
}
